import "./App.css";
import { BrowserRouter } from "react-router-dom";
import PaymentAppDashboard from "./Components/UI/PaymentAppDashboard";
import ChunkLoadErrorBoundary from "./Components/ErrorBoundaries/ChunkLoadErrorBoundary";

const App = () => {
  return (
    <ChunkLoadErrorBoundary>
      <BrowserRouter>
        <PaymentAppDashboard />
      </BrowserRouter>
    </ChunkLoadErrorBoundary>
  );
};

export default App;
